import { cn } from '@/utils/classname';
import * as Portal from '@radix-ui/react-portal';
import { ButtonHTMLAttributes, forwardRef, PropsWithoutRef } from 'react';
import { exploreLayout } from '../layout/ExploreLayout';
import { VIEWER_COLUMN } from '../layout/ExploreLayoutColumn';

export type FabProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const Fab = forwardRef<HTMLButtonElement, PropsWithoutRef<FabProps>>(
  ({ className, ...props }, ref) => {
    const currentColumn = exploreLayout.currentColumn.useValue();
    if (currentColumn !== VIEWER_COLUMN) return null;

    return (
      <Portal.Root>
        <button
          className={cn(
            'fixed bottom-125px right-16px z-50 h-16 w-16 flex items-center justify-center rounded-full border-none bg-primary-400',
            'shadow-black shadow-md shadow-opacity-50',
            'active:transform-scale-95 active:shadow-sm active:filter-brightness-90',
            'transition-all transition-duration-350',
            className,
          )}
          ref={ref}
          {...props}
        >
          <div className="i-skand-annotation text-6 color-neutral-100" />
        </button>
      </Portal.Root>
    );
  },
);

Fab.displayName = 'Fab';
